import firebase from 'firebase'
import { shortLinkConfig } from '@/config.js'

const shortIoUrl = 'https://api.short.cm'

export const shortLink = {
  actions: {
    async updateShortLinkDestination (state, payload) {
      //TODO: this function returns empty data, return something useful
      const updateUrl = firebase.functions()
                             .httpsCallable('updateShortUrlDestination')
      let updateData = {
        allowDuplicates: false,
        originalUrl: payload.originalUrl,
        linkId: payload.linkId
      }
      /*
      TODO: if we ever get a paid short.io plan, we can set the expiration date
            to be the end date of the session
      if (payload.expiresAt) {
        updateData.expiresAt = payload.expiresAt
      }
      */
      const res = await updateUrl(updateData)
      return res
    },
    createShortLink(state, payload) {
      return new Promise((resolve, reject) => {
        const url = `${shortIoUrl}/links/public`
        let body = {
          allowDuplicates: false,
          domain: 'go.vox.media',
          originalURL: payload.originalUrl,
          title: payload.title
        }
        /*
        TODO: if we ever get a paid short.io plan, we can set the expiration date
              to be the end date of the session
        if (payload.expiresAt) {
          updateData.expiresAt = payload.expiresAt
        }
        */
        const options = {
          method: 'post',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: shortLinkConfig.shortIoPublicKey
          },
          body: JSON.stringify(body)
        }
        fetch(url, options)
        .then(res => res.json())
        .then(json => {
          console.log(json)
          return resolve(json)
        })
        .catch(err => {
          return reject(err)
        })
      })
    }
  }
}
